<template>
	<div class="myculture">
		<vs-table ref="table"    :max-items="10"  :data="culturelist">
		  <template slot="thead">
		    <vs-th >ID</vs-th>
		    <vs-th >名称</vs-th>
			<vs-th >姓名</vs-th>
		    <vs-th >备注</vs-th>
			<vs-th >创建时间</vs-th>
			<vs-th >修改时间</vs-th>
			<vs-th >总分</vs-th>
			<vs-th >状态</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody>
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ tr.id }}</p>
		          </vs-td>
		          <vs-td>
		            <p class="product-category">{{ tr.name }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.userName }}</p>
				  </vs-td>
		          <vs-td>
		            <p class="product-price">{{ tr.remarks }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.assessTime }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.updateTime?tr.updateTime:'------' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.totalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price" :class="tr.status==1?'text-danger':tr.status==2?'text-primary':'text-success'" >{{ tr.status==1?"待填写":tr.status==2?"已提交":"已完成" }}</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click="details(tr)"  size="small">填写</vs-button>
					<vs-button class="mr-4" color="rgb(62, 201, 214)" type="filled" @click="submit(tr.id)"  size="small">提交</vs-button>
					<vs-button color="success" type="filled" @click="exportexcel(tr.id)"  size="small">导出Excel</vs-button>
				  </vs-td>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage" ></vs-pagination>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				culturelist: [],
				total:0,
				itemsPerPage:1,
				id:'',
			}
	    },
		mounted() {
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			getlist(){    //获取列表
					 const thisIns = this;
					 this.$api.stafflist({pageNum:thisIns.itemsPerPage,pageSize:10,status:1}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.culturelist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			details(item){  //详情
				localStorage.setItem("userdetails",JSON.stringify(item));
				this.$router.push({path:'/user/myculturedetails',query:{id:item.id}})
			},
			submit(id){   //提交
				this.id=id;
				this.$vs.dialog({
				    type: 'confirm',
				    color: 'warning',
					acceptText:'确定',
					cancelText:'再想想',
				    title: `提示`,
				    text: '您确定提交本月企业文化考核吗?',
				    accept: this.acceptAlert
				})
			},
			acceptAlert(){
				const that = this;
				this.$api.staffsubmit({id:that.id}).then(function (response) {
					console.log("提交结果：",response);
					if(response.code==0){
						 that.$vs.notify({
						 	  title:"提示",
						 	  color:'success',
						 	  text:response.message,
						 	  position:'top-center'
						 });
						 that.getlist();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			exportexcel(id){
				let token = localStorage.getItem('token');
				window.open(`${this.$baseURL}/staffAssess/conserve?id=${id}&authorization=${token}`);
			},
			
		},
	}
</script>
<style type="text/css">
	
</style>
